import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './sections/HeroSection';
import FeaturedProductsSection from './sections/FeaturedProductsSection';
import ProductsSection from './sections/ProductsSection';
import InvestorSection from './sections/InvestorSection';
import AboutSection from './sections/AboutSection';
import ContactSection from './sections/ContactSection';
import FAQSection from './sections/FAQSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Faasley Foods',
      legalName: 'Faasleyfoods Pvt. Ltd.',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/3301efb4abc894ce1097fc48d2d46708/413245a79303f51f4a30352926bd751a.png',
      },
      description: 'India\'s premium packaged food brand offering authentic Makhana snacks, Indian spices, premium tea, pickles and drinking water. FSSAI certified.',
      foundingDate: '2019',
      founder: {
        '@type': 'Person',
        name: 'Kamini Thakur',
        jobTitle: 'Founder & CEO',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+91-8800889959',
        contactType: 'customer service',
        email: 'pari211284@gmail.com',
        availableLanguage: ['English', 'Hindi'],
      },
      sameAs: [
        'https://www.instagram.com/faasley',
        'https://www.facebook.com/faasley',
      ],
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'Faasley Foods',
      description: 'Good Food, Good Mood — Premium Indian packaged food products',
      publisher: { '@id': `${SITE_URL}/#organization` },
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: SITE_URL,
      name: 'Faasley Foods - Good Food Good Mood | Premium Indian Food Products',
      description: 'Faasley Foods Pvt. Ltd. — India\'s premium packaged food brand. Authentic Makhana snacks, Indian spices, premium tea, pickles & drinking water. FSSAI certified.',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      about: { '@id': `${SITE_URL}/#organization` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        ],
      },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);
    document.title = 'Faasley Foods - Good Food Good Mood | Premium Indian Food Products';
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream dark:bg-gray-900 transition-colors duration-300">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProductsSection />
        <ProductsSection />
        <InvestorSection />
        <AboutSection />
        <ContactSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
